import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Existing function (Food/Order statistics)
export const getAdminStatistics = async (fromDate, toDate) => {
  const token = localStorage.getItem("authToken");

  const response = await axios.get(
    `${BASE_URL}/food/api/orders/admin/statistics`,
    {
      // params: { // <--- Use 'params' to automatically build ?fromDate=&toDate=
      //   fromDate: fromDate,
      //   toDate: toDate
      // },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

// NEW FUNCTION: Get Delivery Partner Dashboard Stats
export const getDeliveryPartnerStats = async () => {
  const token = localStorage.getItem("authToken");

  const response = await axios.get(
    `${BASE_URL}/delivery/api/admin/top/partner/dashboard`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};




// NEW FUNCTION: Get Helpdesk Tickets and Count Open Ones
export const getOpenTicketCount = async () => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.get(
      `${BASE_URL}/promotions/api/user/helpdesk/all`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // If response is an array, filter for status 'OPEN'
    if (Array.isArray(response.data)) {
      const openTickets = response.data.filter(
        (ticket) => ticket.status?.toUpperCase() === "OPEN"
      );
      return openTickets.length;
    }

    return 0; // Return 0 if data is not an array
  } catch (error) {
    console.error("Error fetching ticket count:", error);
    return 0; // Fallback to 0 on error
  }
};
